import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import ContactSection from "../../components/common/ContactSection";
import RFQFormContainer from "./RFQFormContainer";

const Form = () => {
  return (
    <>
      <Helmet>
        <title>ANVIYA Biospecimen Services | RFQ Form</title>
      </Helmet>

      <main className="w-full bg-white">
        <Header />

        {/* Main Content: Stepper + Multi-step Forms */}
        <div className="py-[50px] 2xl:py-[100px]">
          <div className="max-w-[1800px] mx-auto px-4 mb-12 text-center">
            <h1 className="text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px] font-extrabold leading-[1.1] text-[#183076]">
              Submit RFQ
            </h1>
            <p className="mt-4 text-[16px] md:text-[20px] 2xl:text-[24px] text-slate-500 max-w-[900px] mx-auto">
              Request for Quote: Human Biospecimen Procurement
            </p>
          </div>

          <RFQFormContainer />
        </div>

        <ContactSection />
        <Footer />
      </main>
    </>
  );
};

export default Form;
